import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BranchFilterService {

  constructor() { }

  getFilteredBranches(branches: any[],accessResponse: any,userBranchId: number): any[] {

    const userId = accessResponse?.user?.id;
    const role = accessResponse?.role?.name;

    const accessControlBranchList = accessResponse?.accessControl
      ?.map((ac: any) => ac.menu?.branches || [])
      ?.reduce((acc: any[], curr: any[]) => acc.concat(curr), []) || [];

    const uniqueBranches = accessControlBranchList.filter(
      (branch, index, self) =>
        index === self.findIndex(b => b.id === branch.id)
    );

    const isPartnerRole =
      role === 'Managing Partner' || role === 'Designated Partner';

    if (isPartnerRole) {
      return branches;
    }

    if (userId) {
      return uniqueBranches;
    }

    return branches.filter(b => b.id === userBranchId);
  }
}
